// Authorization
export const PURGE_AUTH = 'logout'
export const SET_AUTH = 'setAuthentication'

// Orders
export const SET_ORDERS = 'setOrders'
export const SET_ORDER_DETAILS = 'setOrderDetails'

// Management
export const SET_ASSOCIATED_APPROVERS = 'setAssociatedApprovers'
export const SET_ALL_USERS = 'setAllUsers'
